import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Info } from "lucide-react";

const KEY = "roas_basis_global";

export function readStoredBasis() {
  try { return localStorage.getItem(KEY) || "stay"; } catch { return "stay"; }
}

export default function RoasBasisToggle({ value, onChange, size = "md" }) {
  const [search, setSearch] = useSearchParams();
  const current = value || search.get("revenue_basis") || readStoredBasis() || "stay";
  const h = size === "sm" ? "h-7 text-[11px]" : "h-8 text-xs";

  // Sync URL + localStorage when value changes externally
  useEffect(() => {
    const url = search.get("revenue_basis");
    if (url !== current) {
      const next = new URLSearchParams(search);
      next.set("revenue_basis", current);
      setSearch(next, { replace: true });
    }
    try { localStorage.setItem(KEY, current); } catch { /* ignore */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  const set = (b) => {
    onChange?.(b);
    const next = new URLSearchParams(search);
    next.set("revenue_basis", b);
    setSearch(next, { replace: true });
    try { localStorage.setItem(KEY, b); } catch { /* ignore */ }
  };

  return (
    <div className="inline-flex items-center gap-1" data-testid="roas-basis-toggle">
      <div className="inline-flex rounded-md border border-slate-200 bg-slate-50 overflow-hidden">
        <button
          onClick={() => set("stay")}
          className={`px-3 ${h} font-medium transition-colors ${current === "stay" ? "bg-[#F26A1F] text-white" : "text-slate-600 hover:bg-slate-100"}`}
          data-testid="roas-basis-stay"
        >
          住宿日
        </button>
        <button
          onClick={() => set("booking")}
          className={`px-3 ${h} font-medium transition-colors ${current === "booking" ? "bg-[#F26A1F] text-white" : "text-slate-600 hover:bg-slate-100"}`}
          data-testid="roas-basis-booking"
        >
          進單日
        </button>
      </div>
      <HoverCard openDelay={100} closeDelay={80}>
        <HoverCardTrigger asChild>
          <button type="button" className="text-slate-400 hover:text-slate-700" data-testid="roas-basis-info">
            <Info className="h-3.5 w-3.5" />
          </button>
        </HoverCardTrigger>
        <HoverCardContent
          side="bottom"
          align="end"
          sideOffset={8}
          className="w-[320px] bg-white border border-gray-200 text-slate-700 text-xs leading-relaxed p-3 rounded-md shadow-xl"
        >
          <div className="font-semibold text-slate-900 mb-1.5">ROAS 口徑</div>
          <div className="space-y-1.5">
            <div><span className="font-semibold text-slate-800">住宿日</span>:當月入住的收入(傳統會計口徑)</div>
            <div><span className="font-semibold text-slate-800">進單日</span>:當月成立訂單的總金額(對齊廣告投放當月)</div>
            <div className="text-slate-500">旅宿業訂單常提前 1-2 個月成立,進單口徑更能反映廣告投放效益。</div>
          </div>
        </HoverCardContent>
      </HoverCard>
    </div>
  );
}
